var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconInfoPlus = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinecap: "round", strokeLinejoin: "round" },
            React.createElement("g", { transform: "translate(-4.167 -4.167)" },
                React.createElement("path", { d: "M19.4,23.9v-4.8" }),
                React.createElement("path", { d: "M19.4,14.4L19.4,14.4" })),
            React.createElement("path", { d: "M23.6,18.3v8.7" }),
            React.createElement("path", { d: "M19.3,22.6H28" }),
            React.createElement("path", { d: "M15.2,26.8c-6.6,0-11.9-5.3-11.9-11.9S8.6,3,15.2,3c6.6,0,11.9,5.3,11.9,11.9" }))));
});
export default IconInfoPlus;
//# sourceMappingURL=IconInfoPlus.js.map